import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import COLOR_MAP from '../../../../constants/color-mapping';
import PopoverInfoIcon from '../../../../components/PopoverInfoIcon/PopoverInfoIcon';
import InfoUnavailable from '../../../../components/common/InfoUnavailable';

const PediatricPrecautions = forwardRef(function (
  { pediatricPrecautions },
  ref,
) {
  return (
    <div ref={ref} className="mb-36 scroll-offset" id='pediatric-precautions-section'>
      <h4 className="accordion-header">Pediatric Precautions</h4>

      <div className="accordion-body">
        {pediatricPrecautions?.Pediatric_Precautions?.length ? (
          <div>
            <ul className="indicator">
              {pediatricPrecautions.Pediatric_Precautions.map(
                (pediatricPrecaution, index) => (
                  <div key={`pediatric-precaution-${index}`}>
                    <li className='f-18 font-semibold'>{pediatricPrecaution.PrecautionsPediatricDesc}</li>
                    <div className="">
                      <div className="row mb-2">
                        <div className=" col-sm-6 col-12 drug-info">
                          <label>
                            Severity Description
                            <PopoverInfoIcon
                              popoverInfo={COLOR_MAP.PediatricPrecautions}
                            />
                          </label>
                          <p>
                            <span
                              className={
                                COLOR_MAP.PediatricPrecautions[
                                  pediatricPrecaution.SeverityDesc
                                ]
                              }
                            />
                            {pediatricPrecaution.SeverityDesc}
                          </p>
                        </div>
                        <div className=" col-sm-6 col-12 drug-info">
                          <label>Precaution Description</label>
                          <p>{pediatricPrecaution.Narrative}</p>
                        </div>
                        <div className=" col-sm-6 col-12 drug-info ">
                          <label>Age Range</label>
                          <p>{`${pediatricPrecaution.AgeLowDesc} - ${pediatricPrecaution.AgeHighDesc} `}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ),
              )}
            </ul>
          </div>
        ) : (
          <InfoUnavailable />
        )}
      </div>
    </div>
  );
});

PediatricPrecautions.propTypes = {
  pediatricPrecautions: PropTypes.object.isRequired,
};

PediatricPrecautions.displayName = 'PediatricPrecautions';

export default PediatricPrecautions;
